"use client";
import { useState } from "react";
import { Flex, Grid, GridItem, Box, Stack } from "@chakra-ui/react";
import { Balancer } from "react-wrap-balancer";
import { Heading, Text, Button } from "@/elements";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";
import Intro from "@/components/intro";
import SafeView from "@/components/safeView";
import { APPS_DATA, APPS_LIST, APPS_CONSTANTS } from "./constants";

const AppsComp = () => {
  const [selectedApp, setSelectedApp] = useState(APPS_LIST[0].key);
  const headingVariant = useHeadingVariant();

  return (
    <Stack gap={10} id="apps" mt={20}>
      <SafeView>
        <Heading as="h1" variant={headingVariant} textAlign={"center"} mb={8}>
          {APPS_CONSTANTS.title}
        </Heading>
        <Balancer>
          <Text variant={"body1"} color={"text.100"} textAlign={"center"} px={{ lg: 4 }}>
            {APPS_CONSTANTS.desc}
          </Text>
        </Balancer>
      </SafeView>
      <Grid templateColumns={{ base: "1fr", lg: "repeat(5, 1fr)" }} gap={4}>
        <GridItem
          colSpan={{ base: 1, lg: 1 }}
          bg="gray.100"
          px={6}
          py={4}
          borderRadius="lg"
          pl={{
            lg: "3rem",
            xl: "5rem",
            "2xl": "calc(calc(100vw - 1600px) / 2)",
            // "3xl": "calc(calc(100vw - 1800px) / 2)",
          }}
        >
          <Flex
            gap={{ base: 3, lg: 6 }}
            direction={{ base: "column", sm: "row", lg: "column" }}
            wrap="wrap"
            align="center"
            h="full"
          >
            <Box display={{ base: "none", lg: "block" }}>
              <Heading
                as="h1"
                variant={headingVariant}
                marginTop="10px"
                textAlign={"center"}
              >
                Apps
              </Heading>
            </Box>
            {APPS_LIST.map((app) => (
              <Button
                key={app.key}
                onClick={() => setSelectedApp(app.key)}
                variant="outline"
                borderWidth="1px"
                borderColor={selectedApp === app.key ? "black" : "gray.300"}
                bg={selectedApp === app.key ? "primary.200" : "white"}
                color={selectedApp === app.key ? "white" : "black"}
                _hover={{
                  bg: "primary.200",
                  color: "white",
                }}
                py={4}
                borderRadius="40px"
                w={{ base: "fit-content", lg: "100%" }}
                textAlign="center"
              >
                {app.label}
              </Button>
            ))}
          </Flex>
        </GridItem>
        <GridItem
          colSpan={{ base: 1, lg: 4 }}
          bg="gray.100"
          px={6}
          py={4}
          borderRadius="lg"
          pr={{
            lg: "3rem",
            xl: "5rem",
            "2xl": "calc(calc(100vw - 1600px) / 2)",
            // "3xl": "calc(calc(100vw - 1800px) / 2)",
          }}
        >
          {APPS_DATA.map((app) => (
            <Box key={app.key} display={selectedApp === app.key ? "block" : "none"}>
              <Intro {...app} />
            </Box>
          ))}
        </GridItem>
      </Grid>
    </Stack>
  );
};

export default AppsComp;
